import React, { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Box, IconButton, Typography, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import SearchIcon from "@mui/icons-material/Search"
import MenuBookIcon from "@mui/icons-material/MenuBook"
import ChatIcon from "@mui/icons-material/Chat"
import HistoryIcon from "@mui/icons-material/History"
import LogoutIcon from "@mui/icons-material/Logout"
import HomeIcon from "@mui/icons-material/Home"
import ContactSupportIcon from "@mui/icons-material/ContactSupport"
import UserContext from "../context/UserContext"
import { F_INDEX, F_TRADING_ACTIVE, F_TRADING_CHAT, F_TRADING_HISTORY, F_TRADING_SEARCH } from "../constants/routes"

const HeaderMobile = ({ handleLogout, handleSupport }) => {
  const [menuOpen, setMenuOpen] = useState(false)

  const { userData } = useContext(UserContext)
  const navigate = useNavigate()

  const schoolName = userData?.school?.name || userData?.user?.name
  const userEmail = userData?.user?.email || schoolName

  const goTo = (route) => {
    navigate(route)
    setMenuOpen(false)
  }

  return (
    <>
      <IconButton
        onClick={() => setMenuOpen(true)}
        sx={{
          left: "1vw",
          top: "1vw",
          zIndex: 1200,
        }}>
        <MenuIcon sx={{ color: "secondary.main" }} />
      </IconButton>

      <Drawer
        anchor="left"
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        PaperProps={{
          sx: {
            width: "80vw",
            maxWidth: 320,
            borderTopRightRadius: 16,
            borderBottomRightRadius: 16,
          },
        }}>
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Header */}
          <Box sx={{ p: 3, backgroundColor: "secondary.light" }}>
            <Typography variant="h6" sx={{ color: "#FFF" }}>
              {schoolName}
            </Typography>
            <Typography variant="body2" sx={{ color: "#FFF" }}>
              {userEmail}
            </Typography>
          </Box>

          <Divider />

          {/* Navigation */}
          <List>
            <ListItemButton onClick={() => goTo(F_TRADING_SEARCH)}>
              <ListItemIcon>
                <SearchIcon />
              </ListItemIcon>
              <ListItemText primary="Bücherlisten" />
            </ListItemButton>

            <ListItemButton onClick={() => goTo(F_TRADING_ACTIVE)}>
              <ListItemIcon>
                <MenuBookIcon />
              </ListItemIcon>
              <ListItemText primary="Meine Bücher" />
            </ListItemButton>

            <ListItemButton onClick={() => goTo(F_TRADING_CHAT)}>
              <ListItemIcon>
                <ChatIcon />
              </ListItemIcon>
              <ListItemText primary="Chat" />
            </ListItemButton>

            <ListItemButton onClick={() => goTo(F_TRADING_HISTORY)}>
              <ListItemIcon>
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText primary="Verlauf" />
            </ListItemButton>
          </List>

          <Divider sx={{ mt: "auto" }} />

          {/* Footer */}
          <List>
            <ListItemButton onClick={() => navigate(F_INDEX)}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Startseite" />
            </ListItemButton>

            <ListItemButton onClick={handleSupport}>
              <ListItemIcon>
                <ContactSupportIcon />
              </ListItemIcon>
              <ListItemText primary="Support" />
            </ListItemButton>

            <ListItemButton
              onClick={() => {
                setMenuOpen(false)
                handleLogout()
              }}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItemButton>
          </List>

          <Box sx={{ textAlign: "center", pb: 2 }}>
            <Typography variant="caption" color="secondary.main">
              made in berlin
            </Typography>
            {/* <Typography variant="caption" display="block" color="secondary.main">
              v4.0 (Ku.)
            </Typography> */}
          </Box>
        </Box>
      </Drawer>
    </>
  )
}

export default HeaderMobile
